module.exports = __webpack_public_path__ + "assets/img/3_1227.516e34fe.jpg";